import styles from './RubricComponent.module.css';
import MathRenderer from '@components/mathjaxcomponent/MathJaxComponent';

interface RubricProps {
  title: string;
  content: string;
  contentType?: 'latex' | 'mathml' | 'auto';
}

const RubricComponent = ({ title, content, contentType = 'auto' }:RubricProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>{title}</div>
      <div className={styles.contentWrapper}>
      <MathRenderer content={content} />
      </div>
    </div>
  );
};

export default RubricComponent;
